<div class="tw-flex tw-flex-row tw-h-full">
    <div class="tw-w-full">
        <mat-tab-group mat-stretch-tabs="true" [selectedIndex]="tabIndex" color="primary" class="tw-h-full"
                (selectedTabChange)="tabPanelChange.emit($event.tab.textLabel)">
            <mat-tab label="{{'ITEMS.DETAILS.GENERAL' | translate}}"><ng-content select="[Generale]"></ng-content></mat-tab>
            <mat-tab label="{{'ITEMS.DETAILS.DETAILS' | translate}}"><ng-content select="[Dettagli]"></ng-content></mat-tab>
            <mat-tab label="{{'ITEMS.DETAILS.VARIATIONS' | translate}}"><ng-content select="[Varianti]"></ng-content></mat-tab>
            <mat-tab label="{{'ITEMS.DETAILS.STOCK' | translate}}"><ng-content select="[Magazzino]"></ng-content></mat-tab>
            <mat-tab label="{{'ITEMS.DETAILS.CHANNELS' | translate}}"><ng-content select="[Canali]"></ng-content></mat-tab>
        </mat-tab-group>
    </div>
</div>
